import {
  Component,
  Input,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { BaseProductDetailComponent } from '@products/base-product-detail.component';
import { BarChartComponent } from '@shared/bar-chart/bar-chart.component';
import { BarChartData, PortfolioDisplay } from '@types';
import { Logger } from '@utils/logger';

const logger = Logger.getLogger('PortfolioChartsComponent');

@Component({
  selector: 'ft-portfolio-charts',
  templateUrl: './portfolio-charts.component.html',
  styleUrls: ['./portfolio-charts.component.scss'],
})
export class PortfolioChartsComponent
  extends BaseProductDetailComponent
  implements PortfolioDisplay, OnInit {
  @ViewChildren(BarChartComponent) charts: QueryList<BarChartComponent>;

  @Input() data: BarChartData[];
  public containerWideClass: string;
  // this is needed because parent class has protected constructor
  constructor() {
    super();
  }

  ngOnInit(): void {
    this.containerWideClass = this.component?.getParameters().hasContainerWideClass;
    logger.debug(this.containerWideClass);
  }

  resizeChart(): void {
    logger.debug('resizeChart() called');
    this.charts.forEach((chart: BarChartComponent): void => {
      chart.resizeChart();
    });
  }
}
